import firebase from 'firebase'
import "firebase/firestore"

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const environment = {
    production: false,
    apiKey: "AIzaSyCIDR8-rrJcS7b7ZLQEizsLKii6W0_7jYM",
    authDomain: "jobnoterdev.firebaseapp.com",
    projectId: "jobnoterdev",
    storageBucket: "jobnoterdev.appspot.com",
    messagingSenderId: "1046200112333",
    appId: "1:1046200112333:web:98a8e865f9d821618d8584",
    measurementId: "G-HHV47WN6P3"
};

firebase.initializeApp(environment);

export const firestore = firebase.firestore();

export const storage = firebase.storage();

export const auth = firebase.auth();

export const addJob = () => {
    return firestore.collection('jobs')
        .add({
            created: firebase.firestore.FieldValue.serverTimestamp(),
            // createdBy: userId,
        });
};